import React from 'react';
import { TrendingUp, ArrowUpRight } from 'lucide-react';
import { CASE_STUDIES } from '../mock';

const CaseStudies = () => {
  return (
    <section id="case-studies" data-testid="case-studies-section" className="relative bg-[#F7F9FC] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div className="max-w-2xl">
            <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#2AA8E8]">Excelence in Action</span>
            <h2 className="mt-3 text-3xl md:text-5xl font-extrabold text-[#0A1628] leading-[1.05]">
              Performance That <span className="gold-text">Moves Business</span>
            </h2>
          </div>
          <p className="text-sm md:text-base text-[#4A5A72] max-w-md leading-relaxed">
            Three snapshots of what operational discipline looks like in the real world — measured, repeatable and accountable.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {CASE_STUDIES.map((c, i) => (
            <article
              key={c.title}
              data-testid={`case-study-${i + 1}`}
              className="group relative bg-white rounded-2xl border border-[#E5EAF2] overflow-hidden hover:border-[#0A1628] transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/75 via-[#0A1628]/15 to-transparent" />
                <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/95 text-[#0A1628] text-[10px] font-bold uppercase tracking-widest">
                  <TrendingUp className="w-3 h-3" /> {c.tag}
                </span>
              </div>

              {/* KPI strip */}
              <div className="px-6 pt-6">
                <div className="flex items-baseline gap-3">
                  <div className="text-4xl md:text-5xl font-extrabold text-[#0A1628] tracking-tight leading-none">
                    {c.kpi}
                  </div>
                  <div className="text-[11px] font-bold uppercase tracking-widest text-[#4A5A72]">
                    {c.kpiLabel}
                  </div>
                </div>
                <div className="h-1 w-16 bg-[#D4A24C] mt-3 rounded-full" />
              </div>

              {/* Body */}
              <div className="p-6 pt-4">
                <h3 className="text-xl font-extrabold text-[#0A1628] mb-2 leading-snug">
                  {c.title}
                </h3>
                <p className="text-sm text-[#4A5A72] leading-relaxed mb-5">
                  {c.copy}
                </p>
                <a
                  href="/contact"
                  className="inline-flex items-center gap-1.5 text-sm font-bold text-[#0A1628] hover:text-[#2AA8E8] transition-colors"
                >
                  Talk to dispatch
                  <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
